/**
 * Talewave 品牌 - Member 页面 配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

export const theme = {
  avatarBorder: '#FFFFFF',
  btnPrimaryBg: '#F3EEFF',
  vipSubscribeBg: 'url(/images/talewave/profile/tw_bg_vip_mine.png)',
} as const

export const resources = {
  userBg: '/images/talewave/profile/tw_bg_profile.png',
  userDefaultAvatar: '/images/talewave/profile/tw_avatar.png',
  memberVip: '/images/talewave/member-vip.png',
  memberVipDiscount: '/images/talewave/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  showLoginBtn: false,
  theme,
  resources,
  texts: {
    ...memberCommonConfig.texts,
    vipTitle: 'Become a VIP Member',
    vipSubtitle: 'Unlimited reading & downloads',
  },
  menuIcons: {
    transaction: '/images/talewave/profile/tw_ic_mine_transaction_history.png',
    unlocked: '/images/talewave/profile/tw_ic_mine_chapters_unlocked.png',
    contactUs: '/images/talewave/profile/tw_ic_mine_contactus.png',
    setting: '/images/talewave/profile/tw_ic_mine_setting.png',
  },
}
